// extracted by mini-css-extract-plugin
module.exports =  {"body":"H8IEcLkux4LGZeqAz0QM"};